export default function TickCircleIcon() {
  return (
    <>
      <path
        d='M15.75 4.48535C13.2525 4.23785 10.74 4.11035 8.235 4.11035C6.75 4.11035 5.265 4.18535 3.78 4.33535L2.25 4.48535'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.375 3.7275L6.54 2.745C6.66 2.0325 6.75 1.5 8.0175 1.5H9.9825C11.25 1.5 11.3475 2.0625 11.46 2.7525L11.625 3.7275'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.1344 6.85547L13.6469 14.408C13.5644 15.5855 13.4969 16.5005 11.4044 16.5005H6.58937C4.49687 16.5005 4.42938 15.5855 4.34688 14.408L3.85938 6.85547'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.75 12.375H10.2475'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.125 9.375H10.875'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
